// require('turbolinks').start()
// require('@rails/activestorage').start()
// require('channels')

import '@/shared/'
import '@/accounts/'
require('@rails/ujs').start()
